module.exports = __webpack_public_path__ + "static/img/icon1.e154be6b.png";